import { ShoppingCart, CreditCard, Trash2 } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { discountOf } from "@/components/campaign/CheckoutExtras";
import { locItem, money, Qty } from "@/components/campaign/ServiceCatalog";

export const cartLines = (items, cart) => (items || []).filter((i) => cart[i.id] > 0)
  .map((i) => ({ ...i, qty: cart[i.id], subtotal: i.price * cart[i.id] }))
  .sort((a, b) => a.price - b.price || String(a.code).localeCompare(String(b.code)));

export const CartBox = ({ lines, setQty, discount }) => {
  const { lang, tr } = useLang();
  const gross = lines.reduce((a, l) => a + l.subtotal, 0);
  const off = discountOf(discount, gross);
  return (
    <div data-testid="cart-box" className="border border-[#2B3036] bg-[#2B3036] text-white p-6 relative overflow-hidden">
      <div className="absolute -top-10 -right-10 w-32 h-32 rounded-full opacity-30 blur-2xl aurora-gradient-radial" />
      <div className="relative">
        <div className="flex items-center gap-2 text-[10px] uppercase tracking-widest text-[#a1a1aa] font-mono mb-4"><ShoppingCart className="w-3.5 h-3.5" /> {tr("Il tuo carrello", "Your cart")} · {lines.length}</div>
        {!lines.length && <p data-testid="cart-empty" className="text-sm text-[#c4c9ce] mb-4">{tr("Il carrello è vuoto: aggiungi almeno un servizio al passo 6.", "Your cart is empty: add at least one service in step 6.")}</p>}
        <ul className="space-y-3 mb-4">
          {lines.map((l) => (
            <li key={l.id} data-testid={`cart-line-${l.id}`} className="flex items-center gap-3 text-sm">
              <div className="flex-1 min-w-0">
                <div className="truncate">{locItem(l, lang).name}</div>
                <div className="text-[10px] font-mono text-[#a1a1aa]">{money(l.price)} × {l.qty} · {l.days} {tr("giorni", "days")}</div>
              </div>
              <div className="text-[#2B3036]"><Qty qty={l.qty} onChange={(q) => setQty(l.id, q)} testid={`cart-qty-${l.id}`} /></div>
              <span dir="ltr" className="font-mono text-xs w-20 text-right">{money(l.subtotal)}</span>
              <button type="button" data-testid={`cart-remove-${l.id}`} onClick={() => setQty(l.id, 0)} className="text-[#a1a1aa] hover:text-[#E0262C]"><Trash2 className="w-4 h-4" /></button>
            </li>
          ))}
        </ul>
        <div className="pt-3 border-t border-[#3f454c]">
          {off > 0 && <div data-testid="price-gross" className="text-lg font-mono text-[#a1a1aa] line-through">{money(gross)}</div>}
          <div data-testid="price-amount" dir="ltr" className="font-display text-5xl aurora-text">{money(gross - off)}</div>
          {off > 0 && <div data-testid="price-discount" className="text-xs font-mono text-[#34d399] mt-1">{tr("Sconto", "Discount")} {discount.code}: -{money(off)}</div>}
          <div className="text-[10px] font-mono text-[#a1a1aa] mt-1">{tr("Non soggetto IVA · fattura PDF inclusa", "Not subject to VAT · PDF invoice included")}</div>
        </div>
        <div className="mt-4 pt-3 border-t border-[#3f454c] text-[10px] font-mono text-[#a1a1aa] flex items-center gap-1.5">
          <CreditCard className="w-3 h-3" /> {tr("Carta", "Card")} · PayPal · TWINT — {tr("pagamento sicuro Stripe", "secure Stripe payment")}
        </div>
      </div>
    </div>
  );
};
